(function () {
  "use strict";

  angular.module("virtualFairs")
    .controller("VirtualFairPostNetworkingController", VirtualFairPostNetworkingController);

  VirtualFairPostNetworkingController.$inject = ["VirtualFairService", "virtualFairs", "isPlatformRental"];

  function VirtualFairPostNetworkingController(VirtualFairService, virtualFairs, isPlatformRental) {
    var vm = this;
    vm.flag = false;
    vm.virtualFairSelected = false;
    vm.getByFilter = getByFilter;
    vm.downloadCSV = downloadCSV;
    vm.partners = [];
    vm.slots = [];
    vm.chat = [];
    vm.isPlatformRental = isPlatformRental;

    function activate() {
      vm.virtualFairs = virtualFairs
    }

    function getByFilter() {
      vm.flag = false;
      vm.query = {};
      vm.query['virtual_fair_id'] = vm.virtualFairSelected;
      VirtualFairService.getPostNetworkingEventsReport(vm.query).then(function(response){
        console.log(response);
          vm.partners = Object.values(response.data.partners);
          vm.slots = Object.values(response.data.has_slots);
          vm.chat = Object.values(response.data.has_chat);
          vm.flag = true;
      });
    }

    function downloadCSV(type) {
      vm.query = {};
      vm.query['virtual_fair_id'] = vm.virtualFairSelected;
      vm.query['type'] = type;
      VirtualFairService.getPostNetworkingEventsCSV(vm.query).success(function (data) {
        var anchor = document.createElement("a");
        anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
        anchor.target = "_blank";
        anchor.download = `post_networking_${type}_${vm.virtualFairSelected}.csv`;
        document.body.appendChild(anchor);
        anchor.click();
        $timeout(function () {
          anchor.remove();
        }, 50);
      });
    }
    
    activate();
  }
})();
